import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LensIcon from "@mui/icons-material/Lens";
import React from "react";
// components/Vehicle/ImageCarousel.tsx

interface ImageCarouselProps {
  images: string[];
  selectedImage: number;
  onSelect: (index: number) => void;
  onPrev: () => void;
  onNext: () => void;
  isDesktop: boolean;
  isSmallScreen?: boolean;
}

const NavigationButton = ({
  position,
  onClick,
}: {
  position: "left" | "right";
  onClick: () => void;
}) => (
  <button
    style={{
      color: "black",
      position: "absolute",
      [position]: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 1,
    }}
    onClick={onClick}
  >
    {position === "left" ? <ArrowBackIosNewIcon /> : <ArrowForwardIosIcon />}
  </button>
);

const ImageIndicators = ({
  images,
  selectedImage,
  onSelect,
}: {
  images: string[];
  selectedImage: number;
  onSelect: (index: number) => void;
}) => (
  <div className="flex justify-center">
    {images.map((_, index) => (
      <span
        key={index}
        onClick={() => onSelect(index)}
        style={{ cursor: "pointer" }}
      >
        <LensIcon
          style={{
            color: selectedImage === index ? "black" : "gray",
            fontSize: "14px",
            margin: "0 2px",
          }}
        />
      </span>
    ))}
  </div>
);

export const ImageCarousel = ({
  images,
  selectedImage,
  onSelect,
  onPrev,
  onNext,
  isDesktop,
}: ImageCarouselProps) => (
  <header style={isDesktop ? { height: "265px" } : { height: "210px" }}>
    <aside style={isDesktop ? { height: "290px" } : { height: "210px" }}>
      <div className="w-full h-full flex items-center justify-center relative">
        {images.length > 0 && (
          <>
            <NavigationButton position="left" onClick={onPrev} />
            <div className="w-full h-full flex overflow-hidden">
              <img
                src={images[selectedImage]}
                className="w-full h-full object-cover"
                alt="Vehicle"
              />
            </div>
            <NavigationButton position="right" onClick={onNext} />
          </>
        )}
      </div>
    </aside>
    <ImageIndicators
      images={images}
      selectedImage={selectedImage}
      onSelect={onSelect}
    />
  </header>
);
